<template>
  <div>
    <v-dialog v-model="dialogproject" width="800" persistent>
     <v-card flat>
      <v-card-title>
        <h3 class="titleText--text">Variable & Group</h3>
        <v-spacer/>
        <v-btn icon @click="dialogproject = false">
          <v-icon color="titleText">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-0">
        <v-simple-table fixed-header>
         <template v-slot:default>
                <thead>
                    <tr>
                      <th class="grey-bg titleText--text font-weight-bold">Variable</th>
                      <th class="text-left grey-bg titleText--text font-weight-bold">Base</th>
                      <th class="text-left grey-bg titleText--text font-weight-bold">Increment</th>
                      <th class="text-left grey-bg titleText--text font-weight-bold">Other</th>
                    </tr>
                </thead>
           <tbody>
               
             <tr v-for="item in itemlistfinal" :key="item.name">
               <td class="grey-bg titleText--text">{{ item.variable }}</td>
               <td class="grey-bg text-right">
                 <v-checkbox 
                  disabled
                  v-model="item.base"
                  on-icon="mdi-checkbox-marked-circle"
                  off-icon="mdi-checkbox-blank-circle-outline"
                  color="blue"
                 ></v-checkbox>
               </td>
               <td class="grey-bg text-center">
                  <v-checkbox
                    style="justify-content: center"
                    v-model="item.increment"
                    on-icon="mdi-checkbox-marked-circle"
                    off-icon="mdi-checkbox-blank-circle-outline"
                    color="blue"
                    @change="OnChangeCheckbox(item.increment, item.variable,1,item.id)">
                  </v-checkbox>
                </td>
               <td class="grey-bg">
                <v-checkbox
                  v-model="item.other"
                  on-icon="mdi-checkbox-marked-circle"
                  off-icon="mdi-checkbox-blank-circle-outline"
                  color="blue"
                  @change="OnChangeCheckbox(item.other, item.variable,2,item.id)">
                </v-checkbox>
              </td>
             </tr>
           </tbody>
         </template>
       </v-simple-table>
      </v-card-text>
     </v-card>
     
      
    </v-dialog>
  </div>
</template>

<script>
import apifactory from "../api";


export default {
  data: () => ({
    itemlistfinal: [],
    dialogproject: false,
    parmVariablename:'Variable and Group '
  }),
  methods: {
    OnChangeCheckbox(selectvalue, varname,selectvartype,varid) {
      //alert(selectvalue);
      //alert(varname);
      //alert(selectvartype);
      //alert(varid);
      //let count=0;
      console.warn(varid);
      if(!selectvalue)
      {
        selectvartype=0;
      }
      
      this.call_api_save_vargrp_for_model(varname,selectvartype);
      /*
      for(let element in this.itemlistfinal)
      {
          if(this.itemlistfinal[element].id ==varid )
          {
              if(this.itemlistfinal[element].base == true){
                 // this.call_api_save_vargrp_for_model(varname,1);
                  //this.call_api_save_vargrp_for_model(varname,1);
                count=count+1;
              }
               if(this.itemlistfinal[element].increment == true){
                count=count+1;
              }
               if(this.itemlistfinal[element].other == true){
                count=count+1;
              }
          }
      }
      */
     // alert(count);
      //this.call_api_save_vargrp_for_model(varname,);
     
    },
    OnloadCall() {
     // alert("call OnloadCall");
      this.dialogproject = true;
      this.get_saved_vargrp_for_model();
    },
      call_api_save_vargrp_for_model(variablename,vargroup) {
      apifactory
        .api_save_vargrp_for_model(variablename,vargroup)
        .then((res) => {
          // alert(res.id);
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.OnloadCall();
         
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    get_saved_vargrp_for_model() {
      apifactory
        .api_get_vargrp_for_model()
        .then((res) => {
          // alert(res.id);
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            let templist = [];
            templist = res.data.variable_groups;
            //alert(JSON.stringify(templist));
            let finallist = [];
            let index=1;
            for (let element in templist) {
              let obj = new Object();
              obj.id=index;
              obj.variable = element;
              obj.base = false;
              obj.increment = false;
              obj.other = false;
              if (templist[element] == "0") {
                obj.base = true;
              }
              if (templist[element] == "1") {
                obj.increment = true;
              }
              if (templist[element] == "2") {
                obj.other = true;
              }
              obj.value = templist[element];
              index=index+1;
              finallist.push(obj);
              //alert(element);
            }
            this.itemlistfinal = finallist;
            //alert(JSON.stringify(finallist));
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.headerbox {
  font-weight: bold;
  font-style: italic;
  font-size: 25px;
  color: black;
}

.headerboxtitle {
  font-size: 20px;
}

.grey-bg {
  background: rgb(243, 245, 248, .4) !important
}
.card2 {
  background-color: #ffff00;
}

table td {
  border: none !important;
}

table thead,
table tr {
  border: none !important;
}
</style>
